import ErrorUtils from '~/utils/error_utils';

export default {
    getOrgSecurityQuestions(retrieveAll = true) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/security-questions/get-org-security-questions',
                type: 'GET',
                data: {
                    retrieveAll: retrieveAll
                }
            })
            .done((json) => {
                resolve(json);
            })
            .fail((xhr) => {
                reject(xhr);
            });
        });
    },

    getSecurityQuestionAnswersData() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/security-questions/security-questions-form-json' ,
                type: 'GET'
            })
            .done((json) => {
                resolve(json);
            })
            .fail((xhr) => {
                reject(xhr);
            });
        });
    },

    updateSecurityQuestionAnswers(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/security-questions/security-questions',
                type: 'POST',
                data: payload,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    }
};